import { Button } from "@/components/ui/button";

interface MicrosoftButtonProps {
  mode: "login" | "register";
  onClick: () => void;
}

export function MicrosoftButton({ mode, onClick }: MicrosoftButtonProps) {
  return (
    <Button 
      variant="outline" 
      type="button"
      onClick={onClick}
      className="w-full flex items-center justify-center gap-2 h-11 text-base bg-[#fffefa] dark:bg-[#141b2a] hover:bg-accent"
    >
      <img src="/microsoft-logo.svg" alt="Microsoft logo" className="w-5 h-5" />
      <span>
        {mode === "login" ? "Continue with Microsoft" : "Sign up with Microsoft"}
      </span>
    </Button>
  );
}